import React, { Component } from "react";
import { bindActionCreators } from "redux";

import ScreenShare from "./ScreenShare";
import { connect } from "react-redux";
import {
  selectSessionKey,
  selectCurrentParticipantUniqueId,
  getIsRecording,
  getVideoRecordingMessage,
  getRecordingMethod,
  getRecordingTarget,
  getIsFullScreenV2,
} from "REDUX/Selector/SessionSelector";
import { sendWebsocketMessage } from "WEBSOCKET/WebsocketHandler";

// Constants
import {downloadableModules, screenshareSubModules, MAX_Z_INDEX} from "UTILS/Constants";

import { sessionActions } from "CONFIG/ActionFactory";

import { getFirstNamebyParticipantId, isAndroidPhone } from "UTILS/Utility";

import { selectUniqueId, getUserRole } from "../../Routes/selectors";
import { selectAllowedDownloads, selectSubModulesScreenshare } from "../CommonComponents/Header/selectors";
import { selectTurnServerData, getScreenshareBandwidthSettings, getScreenshareCustomBandwidthSettings } from "../Video/selectors";
import { getAdmittedParticipants, selectLatestUpdatedParticipant } from "../CommonComponents/Header/selectors"
import { selectShowSnapshot, selectSnapshoteeId, selectSnapshotPermissionReply, getIsScreenMasking, getRunScreenShare } from "REDUX/Selector/SessionSelector";
import { getShowCustomerCoBrowse } from "COMPONENTS/CustomerCoBrowse/CustomerCoBrowseSelector";
import { getShowAudioVideoComponentFlag } from "COMPONENTS/Dashboard/selectors"

import FullScreenTargetComponent from "COMPONENTS/FullScreen/FullScreenTargetComponent"
import ScreenShareSide from './ScreenShareSide';
import { getDeviceOrientation } from '@/Redux/Selector/UserSelector';
import { getSelectedLanguage } from '@/Redux/Selector/LanguageSelector';

export class ScreenShareContainer extends FullScreenTargetComponent {

  constructor(props) {
    super(props);
    this.toggleScreenZoomIn = this.toggleScreenZoomIn.bind(this);
    this.peerError = null;
  }

  isScreenShareDownloadAllowed = () => {
    return this.props.allowedDownloads && this.props.allowedDownloads.hasOwnProperty(downloadableModules.SCREENSHARE)
  }
  
  isViewScreenShare = () => {
    return this.props.subModulesScreenshare && this.props.subModulesScreenshare.hasOwnProperty(screenshareSubModules.VIEW_SCREEN)
  }
  isConfirmScreenShare = () => {
    return this.props.subModulesScreenshare && this.props.subModulesScreenshare.hasOwnProperty(screenshareSubModules.CONFIRM_SCREEN)
  }

  putPeerError = (error) => {
    this.peerError = error;
  }
  isPeerError = () => {
    if (this.peerError) {
      return true;
    }
    return false;
  }
  clearPeerError = () => {
    this.peerError = null;
  }

  componentDidUpdate(prevProps) {
    if (!this.isFullScreenV2Target() && this.props.isFullScreenV2 && !prevProps.isFullScreenV2 &&
        this.props.screenSharingParticipantId !== this.props.currentParticipantUniqueId) {
      this.props.putFullScreenV2Target(this);
    } else if(this.props.screenSharingParticipantId === null && prevProps.screenSharingParticipantId && this.isFullScreenV2Target() ) {
      this.props.removeFullScreenV2Target(this);
    }
  }

  componentWillUnmount() {
    if(this.isFullScreenV2Target()) {
      this.props.removeFullScreenV2Target(this);
    }
  }

  toggleScreenZoomIn = async () => {
    if ( this.props.horizontalDisplayFixed && isAndroidPhone() ) {
      return (await this.props.handleFullScreenV2(this) );
    }
    return false;
  }

  getMaxZIndex = () => {
    return MAX_Z_INDEX.SCREEN_SHARE;
  }

  putFullScreenV2Target = () => {
    if (!this.isFullScreenV2Target()) {
      this.props.putFullScreenV2Target(this);
    }
  }

  renderInFullScreen = (isMain) => {
    return (
      <ScreenShare
        screenSharingParticipantId={this.props.screenSharingParticipantId}
        currentParticipantUniqueId={this.props.currentParticipantUniqueId}
        screenShareId="screenshareFSV2"
        sessionKey={this.props.sessionKey}
        sendWebsocketMessage={this.props.sendWebsocketMessage}
        uniqueId={this.props.uniqueId}
        userRole={this.props.userRole}
        isScreenShareDownloadAllowed={this.isScreenShareDownloadAllowed()}
        isViewScreenShare={this.isViewScreenShare()}
        broadcastDownloadAction={this.props.broadcastDownloadAction}
        turnServer={this.props.turnServer}
        sessionActions={sessionActions}
        screenSharePresenterName={getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId)}
        presenterId={this.props.presenterId}
        latestUpdatedParticipant={this.props.latestUpdatedParticipant}
        admittedParticipants={this.props.admittedParticipants}
        setComponentInFocus={this.props.setComponentInFocus}
        isLandscape={this.props.isLandscape}
        screenshareBandwidthSettings={this.props.screenshareBandwidthSettings}
        screenshareCustomBandwidthSettings={this.props.screenshareCustomBandwidthSettings}
        showCustomerCoBrowse={this.props.showCustomerCoBrowse}
        showSnapshot={this.props.showSnapshot}
        snapshoteeId={this.props.snapshoteeId}
        snapshotPermissionReply={this.props.snapshotPermissionReply}
        componentInFocus={this.props.componentInFocus}
        isRecording={this.props.isRecording}
        videoRecordingMessage={this.props.videoRecordingMessage}
        recordingMethod={this.props.recordingMethod}
        recordingTarget={this.props.recordingTarget}
        isScreenMasking={this.props.isScreenMasking}
        runScreenShare={this.props.runScreenShare}
        handleFullScreenV2={this.props.handleFullScreenV2}
        isFullScreenV2={this.props.isFullScreenV2}
        inFullScreenV2Container={true}
        isPeerError={this.isPeerError}
        isConfirmScreenShare={this.isConfirmScreenShare()}
        isHideBar={this.props.isHideBar}
        toggleHideBar={this.props.toggleHideBar}
      />
    );
  };

  render() {
    return (
      this.props.screenShareId == "screenshare" ? (
        <ScreenShare
          screenSharingParticipantId={this.props.screenSharingParticipantId}
          currentParticipantUniqueId={this.props.currentParticipantUniqueId}
          screenShareId={this.props.screenShareId}
          sessionKey={this.props.sessionKey}
          sendWebsocketMessage={this.props.sendWebsocketMessage}
          uniqueId={this.props.uniqueId}
          userRole={this.props.userRole}
          isScreenShareDownloadAllowed={this.isScreenShareDownloadAllowed()}
          isViewScreenShare={this.isViewScreenShare()}
          broadcastDownloadAction={this.props.broadcastDownloadAction}
          turnServer={this.props.turnServer}
          sessionActions={sessionActions}
          screenSharePresenterName={getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId)}
          presenterId={this.props.presenterId}
          latestUpdatedParticipant={this.props.latestUpdatedParticipant}
          admittedParticipants={this.props.admittedParticipants}
          setComponentInFocus={this.props.setComponentInFocus}
          isLandscape={this.props.isLandscape}
          screenshareBandwidthSettings={this.props.screenshareBandwidthSettings}
          screenshareCustomBandwidthSettings={this.props.screenshareCustomBandwidthSettings}
          showCustomerCoBrowse={this.props.showCustomerCoBrowse}
          showSnapshot={this.props.showSnapshot}
          snapshoteeId={this.props.snapshoteeId}
          snapshotPermissionReply={this.props.snapshotPermissionReply}
          componentInFocus={this.props.componentInFocus}
          isRecording={this.props.isRecording}
          videoRecordingMessage={this.props.videoRecordingMessage}
          recordingMethod={this.props.recordingMethod}
          recordingTarget={this.props.recordingTarget}
          isScreenMasking={this.props.isScreenMasking}
          runScreenShare={this.props.runScreenShare}
          horizontalDisplayFixed={this.props.horizontalDisplayFixed}
          handleFullScreenV2={this.toggleScreenZoomIn}
          isFullScreenV2={this.props.isFullScreenV2}
          inFullScreenV2Container={false}
          putFullScreenV2Target={this.putFullScreenV2Target}
          putPeerError={this.putPeerError}
          clearPeerError={this.clearPeerError}
          isConfirmScreenShare={this.isConfirmScreenShare()}
          isHideBar={this.props.isHideBar}
          toggleHideBar={this.props.toggleHideBar}
          setValue={this.props.setValue}
          screen={this.props.screen}
          isScreenShare={this.props.isScreenShare}
          isZoomOut={this.props.isZoomOut}
          orientation={this.props.orientation}
          language={this.props.language}
          showAudioVideoComponent={this.props.showAudioVideoComponent}
        />
      ) : (
        <ScreenShareSide
          screen={this.props.screen}
          isZoomOut={this.props.isZoomOut}
          isScreenShare={this.props.isScreenShare}
          setValue={this.props.setValue}
          screenShareId={this.props.screenShareId}
          setComponentInFocus={this.props.setComponentInFocus}
          componentInFocus={this.props.componentInFocus}
          screenshareBandwidthSettings={this.props.screenshareBandwidthSettings}
          orientation={this.props.orientation}
          showSnapshot={this.props.showSnapshot}
          snapshoteeId={this.props.snapshoteeId}
          snapshotPermissionReply={this.props.snapshotPermissionReply}
          showCustomerCoBrowse={this.props.showCustomerCoBrowse}
          showAudioVideoComponent={this.props.showAudioVideoComponent}
        />
      )
    ) 
  }
}

const mapStateToProps = state => {
  return {
    currentParticipantUniqueId: selectCurrentParticipantUniqueId(state),    
    sessionKey: selectSessionKey(state),
    screenSharingParticipantId: state.RoomMetaDataReducer.roomMetaData.screenSharingParticipantId,
    uniqueId: selectUniqueId(state),
    userRole: getUserRole(state),
    allowedDownloads: selectAllowedDownloads(state),
    subModulesScreenshare: selectSubModulesScreenshare(state),
    turnServer:selectTurnServerData(state),
    admittedParticipants: getAdmittedParticipants(state),
    latestUpdatedParticipant: selectLatestUpdatedParticipant(state),
    screenshareBandwidthSettings: getScreenshareBandwidthSettings(state),
    screenshareCustomBandwidthSettings: getScreenshareCustomBandwidthSettings(state),
    showCustomerCoBrowse: getShowCustomerCoBrowse(state),
    showSnapshot: selectShowSnapshot(state),
    snapshoteeId: selectSnapshoteeId(state),
    snapshotPermissionReply: selectSnapshotPermissionReply(state),
    isRecording: getIsRecording(state),
    videoRecordingMessage: getVideoRecordingMessage(state),
    recordingMethod: getRecordingMethod(state),
    recordingTarget: getRecordingTarget(state),
    isScreenMasking: getIsScreenMasking(state),
    runScreenShare: getRunScreenShare(state),
    isFullScreenV2: getIsFullScreenV2(state),
    orientation: getDeviceOrientation(state),
    language: getSelectedLanguage(state),
    showAudioVideoComponent: getShowAudioVideoComponentFlag(state)
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      sendWebsocketMessage: sendWebsocketMessage
    },
    dispatch
  );
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScreenShareContainer);
